import { makeStyles } from "@material-ui/styles"
import { CELL_WIDTHS } from "@utils";

const useStyle = makeStyles(() => ({
  
  cell: {
    width: CELL_WIDTHS.VALUE.SMALL,
    minWidth: CELL_WIDTHS.VALUE.SMALL,
  },
  narrow: {
    width: CELL_WIDTHS.VALUE.XXSMALL,
    minWidth: CELL_WIDTHS.VALUE.XXSMALL
  },
}));

export default useStyle;